<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("autoemailreport") }}
      </div>
      <div>
        <router-link class="btn-blue" to="auto-email-report"
          >{{ $t("autoemailreport") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                AutoEmailReportData.userfullname &&
                AutoEmailReportData.userfullname.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("user", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="AutoEmailReportData.userfullname"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search User"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchUser()"
                    v-on:keydown="onSearchUser()"
                    v-model="searchUser"
                  />
                </div>
                <b-dropdown-item
                  v-for="(user, userIndex) in Users"
                  :key="userIndex"
                  @click="OnSelectDropDown(user, 'User')"
                  >{{ user.first_name }} {{ user.middle_name }}
                  {{ user.last_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('select_user')" /> -->
            </div>
            <p class="error_message">
              <span
                v-if="submitted && AutoEmailReportData.userfullname.length == 0"
                >Please Select User.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                AutoEmailReportData.reportname &&
                AutoEmailReportData.reportname.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $t("report") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="AutoEmailReportData.reportname"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Report"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchReport()"
                    v-on:keydown="onSearchReport()"
                    v-model="searchReport"
                  />
                </div>
                <b-dropdown-item
                  v-for="(report, reportIndex) in Reports"
                  :key="reportIndex"
                  @click="OnSelectDropDown(report, 'Report')"
                  >{{ report.rl_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('select_report')" /> -->
            </div>
            <p class="error_message">
              <span
                v-if="submitted && AutoEmailReportData.reportname.length == 0"
                >Please Select Report</span
              >
            </p>
          </div>
        </div>

        <div v-if="show" class="col-lg-6 col-xl-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="
                  AutoEmailReportData.selectedcinema &&
                  AutoEmailReportData.selectedcinema.length > 0
                    ? 'shift-up'
                    : ''
                "
                >Select Cinema</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="AutoEmailReportData.selectedcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="OnSelectDropDown(Cinema, 'Cinema')"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <!-- <Tooltip :title="$t('cinema_email_report')" /> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && AutoEmailReportData.selectedcinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div v-if="showDistributor_and_Movie" class="col-lg-6 col-xl-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="
                  AutoEmailReportData.distributorname &&
                  AutoEmailReportData.distributorname.length > 0
                    ? 'shift-up'
                    : ''
                "
                >Select Distributor</label
              >
              <b-dropdown
                :text="AutoEmailReportData.distributorname"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Distributor"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchDistributor()"
                    v-on:keydown="onSearchDistributor()"
                    v-model="searchDistributor"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(distro, distroIndex) in Distributors"
                  :key="distroIndex"
                  v-on:click="OnSelectDropDown(distro, 'Distributor')"
                  >{{ distro.d_company_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <!-- <Tooltip :title="`Select Distributor for Distributor Collection Report`"  /> -->
          </div>
          <p class="error_message">
            <span
              v-if="
                submitted && AutoEmailReportData.distributorname.length == 0
              "
              >Please Select Distributor.</span
            >
          </p>
        </div>

        <div v-if="showDistributor_and_Movie" class="col-lg-6 col-xl-3 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="
                  AutoEmailReportData.moviename &&
                  AutoEmailReportData.moviename.length > 0
                    ? 'shift-up'
                    : ''
                "
                >Select Movie</label
              >
              <b-dropdown
                :text="AutoEmailReportData.moviename"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(distroMovie, distroMovieIndex) in DistributorsMovies"
                  :key="distroMovieIndex"
                  v-on:click="OnSelectDropDown(distroMovie, 'DistributorMovie')"
                  >{{ distroMovie.movie_title }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <!-- <Tooltip :title="`Select Movie for Distributor Collection Report`"  /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && AutoEmailReportData.moviename.length == 0"
              >Please Select Movie.</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                v-if="AutoEmailReportData.datetime"
                v-on:click="clearDate()"
                class="btn-clearDate"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="AutoEmailReportData.datetime"
                type="date"
                class="theme-custom-date-time"
                typeable
                v-validate="'required'"
              ></Datepicker>
              <label class="active">{{ $t("date") }}</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && !AutoEmailReportData.datetime"
                >Please Date & Time</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <div class="add-datepicker custom-timepicker">
              <vue-timepicker
                manual-input
                v-model="startTime2"
                id="starttime"
                name="starttime"
                placeholder="Start Time"
                format="hh:mm a"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-validate="'required'"
              ></vue-timepicker>
              <label class="active">{{ $t("time") }}</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && !startTime2">Please Date & Time</span>
            </p>
          </div>
        </div>

        <div class="col-lg-12 align-self-center mb-4">
          <div class="row">
            <div class="col-lg-2 col-xl-2">
              <div>{{ $t("frequency") }} :</div>
            </div>
            <div class="col-lg-7 col-xl-4 pl-0">
              <div class="row">
                <b-form-checkbox
                  style="min-width: 100px"
                  class="j-checkbox mb-1"
                  v-model="frequencyDaily"
                  @change="OnSelectfrequency($event, 'Daily')"
                >
                  <div class="text-capitalize">Daily</div>
                </b-form-checkbox>

                <span>OR</span>

                <b-form-checkbox
                  style="min-width: 125px"
                  class="j-checkbox mb-3 ml-5"
                  v-model="frequencyWeekday"
                  @change="OnSelectfrequency($event, 'WeekDays')"
                >
                  <div class="text-capitalize">Days of the Week</div>
                </b-form-checkbox>
              </div>
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted &&
                  frequencyDaily === false &&
                  frequencyWeekday === false
                "
                >Please at least One Frequency.</span
              >
            </p>
          </div>
        </div>

        <div v-if="frequencyWeekday" class="col-lg-12 align-self-center mb-4">
          <div class="row">
            <div class="col-lg-3 col-xl-1">
              <div>{{ $t("select") }} {{ $t("days") }} :</div>
            </div>
            <div class="col-lg-9 col-xl-10 pl-0">
              <div class="row">
                <b-form-checkbox
                  v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                  :key="weekdaysKey"
                  style="min-width: 125px"
                  class="j-checkbox mb-3"
                  @change="OnSelectWeekends($event, weekdaysKey)"
                  v-model="weekDays[weekdaysKey]"
                >
                  <div class="text-capitalize">{{ weekdaysKey }}</div>
                </b-form-checkbox>
              </div>
            </div>
            <p class="error_message">
              <span class="ml-3" v-if="submitted">{{ msgweek }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="AutoEmailReportData.is_active"
                  switch
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                  class="j-checkbox color-blue"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="OnFinalSubmit()" class="btn-blue">
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="auto-email-report"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import ReportsService from "@/services/ReportsService";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      ReportsCopy: [],
      searchReport: "",
      UsersCopy: [],
      searchUser: "",
      DistributorsCopy: [],
      searchDistributor: "",
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      show: true,
      showDistributor_and_Movie: false,
      submitted: false,
      Cinemas: [],
      Users: [],
      Reports: [],
      Distributors: [],
      DistributorsMovies: [],
      frequencyDaily: true,
      frequencyWeekday: false,
      weekDays: {
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
      },
      AutoEmailReportData: {
        id: null,
        userfullname: "",
        reportname: "",
        selectedcinema: "",
        distributorname: "",
        moviename: "",
        movie_id: null,
        d_id: null,
        cine_id: null,
        user_id: null,
        report_id: null,
        datetime: null,
        is_active: "Y",
      },
      msgweek: "",
      CinemaReports: [
        "Summary Report",
        "Performance Report",
        "Daily Sales Report",
        "Distributor Collection Report",
        "COGS Report",
        "Stock Wastage Report",
        "Municipality Report",
        "Advance Booking Report",
      ],
      startTime2: "",
    };
  },
  beforeMount() {
    const { aec_id } = this.$route.query;
    this.GetDetails(aec_id);

    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    this.getCinemasList(obj);
    this.getAllActiveUsers();
    this.getAllActiveReportsList();
    this.getAllDistributors();
  },
  methods: {
    clearDate() {
      this.AutoEmailReportData.datetime = null;
    },
    onSearchReport: function () {
      if (this.searchReport && this.searchReport.length > 0) {
        this.Reports = this.ReportsCopy.filter((x) => {
          if (
            x.rl_name.toLowerCase().includes(this.searchReport.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Reports = this.ReportsCopy;
      }
    },
    onSearchUser: function () {
      if (this.searchUser && this.searchUser.length > 0) {
        this.Users = this.UsersCopy.filter((x) => {
          let full_name = `${x.first_name} ${x.last_name}`;
          if (
            full_name.toLowerCase().includes(this.searchUser.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Users = this.UsersCopy;
      }
    },
    onSearchDistributor: function () {
      if (this.searchDistributor && this.searchDistributor.length > 0) {
        this.Distributors = this.DistributorsCopy.filter((x) => {
          if (
            x.d_company_name
              .toLowerCase()
              .includes(this.searchDistributor.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Distributors = this.DistributorsCopy;
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    GetDetails: function (id) {
      let body = {
        aec_id: id,
      };
      let loader = this.$loading.show();

      MasterService.GetSingleAutoEmailReport(body)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              let obj = data.Records[0];

              this.AutoEmailReportData.id = obj.aec_id;
              this.AutoEmailReportData.userfullname =
                obj.first_name + " " + obj.middle_name + " " + obj.last_name;
              this.AutoEmailReportData.user_id = obj.aec_user_id;
              this.AutoEmailReportData.reportname = obj.rl_name;
              this.AutoEmailReportData.report_id = obj.aec_report_id;

              if (obj.aec_report_id != 2 && obj.aec_report_id != 10) {
                this.isRoleID = true;
              }
              this.AutoEmailReportData.datetime = obj.aec_datetime;
              this.startTime2 = moment(obj.aec_datetime).format("hh:mm a");
              this.AutoEmailReportData.selectedcinema = obj.aec_cinema_name;
              this.AutoEmailReportData.cine_id = obj.aec_cinema_id;

              if (this.CinemaReports.indexOf(obj.rl_name) !== -1) {
                this.show = true;
              } else {
                this.show = false;
              }

              if (
                this.AutoEmailReportData.reportname ==
                "Distributor Collection Report"
              ) {
                this.AutoEmailReportData.d_id = obj.aec_distributor_id;
                this.AutoEmailReportData.distributorname =
                  obj.aec_distributor_company_name;

                this.getMoviesByDistributor(obj.aec_distributor_id);
                this.AutoEmailReportData.movie_id = obj.aec_movie_id;
                this.AutoEmailReportData.moviename = obj.aec_movie_title;

                this.showDistributor_and_Movie = true;
              } else {
                this.showDistributor_and_Movie = false;
              }

              this.weekDays.sunday = obj.aec_sunday == "Y" ? true : false;
              this.weekDays.monday = obj.aec_monday == "Y" ? true : false;
              this.weekDays.tuesday = obj.aec_tuesday == "Y" ? true : false;
              this.weekDays.wednesday = obj.aec_wednesday == "Y" ? true : false;
              this.weekDays.thursday = obj.aec_thursday == "Y" ? true : false;
              this.weekDays.friday = obj.aec_friday == "Y" ? true : false;
              this.weekDays.saturday = obj.aec_saturday == "Y" ? true : false;

              let weekarr = Object.keys(this.weekDays).filter(
                (x) => this.weekDays[x]
              );

              if (weekarr.length >= 7) {
                this.frequencyDaily = true;
              } else {
                this.frequencyWeekday = true;
                this.frequencyDaily = false;
              }

              this.AutoEmailReportData.is_active = obj.aec_is_active;
            }
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.AutoEmailReportData.selectedcinema = x.cine_name;
                this.AutoEmailReportData.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getAllActiveUsers: function () {
      MasterService.GetActiveUsers({ activekey: "is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Users = data.Records;
            this.UsersCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getAllActiveReportsList: function () {
      MasterService.GetActiveReportList({ activekey: "rl_is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Reports = data.Records;
            this.ReportsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getAllDistributors: function () {
      let body = {
        tableName: "ms_distributors",
        d_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Distributors = data.Records;
            this.DistributorsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getMoviesByDistributor: function (d_id) {
      let payload = {
        d_id: d_id,
      };
      ReportsService.GetDistributorMovieFormat(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            this.DistributorsMovies = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    OnSelectDropDown: function (data, type) {
      if (type === "User") {
        (this.searchUser = ""), this.onSearchUser();
        this.AutoEmailReportData.userfullname =
          data.first_name + " " + data.middle_name + " " + data.last_name;
        this.AutoEmailReportData.user_id = data.user_id;

        //if role is not Superadmin, Ho Manager and Aggregator then set cinema based on user cinema_id
        if (data.role_id != 2 && data.role_id != 10) {
          this.isRoleID = true;
          this.Cinemas.map((x) => {
            if (String(data.cinema_id) === String(x.cine_id)) {
              this.AutoEmailReportData.selectedcinema = x.cine_name;
              this.AutoEmailReportData.cine_id = x.cine_id;
            }
          });
        } else {
          this.isRoleID = false;
          this.AutoEmailReportData.selectedcinema = "";
          this.AutoEmailReportData.cine_id = null;
        }
      } else if (type === "Report") {
        this.AutoEmailReportData.reportname = data.rl_name;
        this.AutoEmailReportData.report_id = data.rl_id;
        this.searchReport = "";
        this.onSearchReport();

        //matching report name with list of report if matched then showing cinema dropdown
        if (this.CinemaReports.indexOf(data.rl_name) !== -1) {
          //if report matched but user dropdown is not selected then cinema dropdown will be disabled
          if (
            this.AutoEmailReportData.userfullname.length == 0 &&
            this.AutoEmailReportData.user_id == null
          ) {
            //if Distributor Collection Report selected then show Distributor and Movie Dropdown
            if (data.rl_name == "Distributor Collection Report") {
              this.showDistributor_and_Movie = true;
            } else {
              this.showDistributor_and_Movie = false;
              this.AutoEmailReportData.distributorname = "";
              this.AutoEmailReportData.d_id = null;

              this.AutoEmailReportData.moviename = "";
              this.AutoEmailReportData.movie_id = null;
            }

            this.show = true;
          } else {
            //if Distributor Collection Report selected then show Distributor and Movie Dropdown
            if (data.rl_name == "Distributor Collection Report") {
              this.showDistributor_and_Movie = true;
            } else {
              this.showDistributor_and_Movie = false;
            }
            this.show = true;
          }
        } else {
          this.show = false;
          this.showDistributor_and_Movie = false;
        }
      } else if (type === "Cinema") {
        this.AutoEmailReportData.selectedcinema = data.cine_name;
        this.AutoEmailReportData.cine_id = data.cine_id;
        this.searchCinema = "";
        this.onSearchCinema();
      } else if (type === "Distributor") {
        if (
          this.AutoEmailReportData.user_id == null &&
          this.AutoEmailReportData.cine_id == null
        ) {
          this.$toasted.show(
            "First Select User and Select Cinema Before Select Distributor"
          );
        } else {
          this.searchDistributor = "";
          this.onSearchDistributor();
          this.AutoEmailReportData.distributorname = data.d_company_name;
          this.AutoEmailReportData.d_id = data.d_id;

          this.getMoviesByDistributor(data.d_id);
        }
      } else if (type === "DistributorMovie") {
        this.AutoEmailReportData.moviename = data.movie_title;
        this.AutoEmailReportData.movie_id = data.movie_id;
      }
    },
    OnSelectfrequency: function (event, day) {
      if (day === "Daily") {
        this.frequencyDaily = true;
        this.frequencyWeekday = false;
        this.weekDays = {
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        };
      } else {
        this.frequencyWeekday = true;
        this.frequencyDaily = false;
      }
    },
    OnSelectWeekends: function (event, days) {
      this.weekDays;
      this.msgweek = "";
    },
    convertTime(date, time) {
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format("YYYY-MM-DD HH:mm");
      return newdate;
    },
    OnFinalSubmit: function () {
      this.submitted = true;
      let weekarr = Object.keys(this.weekDays).filter((x) => this.weekDays[x]);

      if (
        this.AutoEmailReportData.userfullname.length == 0 &&
        this.AutoEmailReportData.user_id == null
      ) {
        return;
      } else if (
        this.AutoEmailReportData.report_id == null &&
        this.AutoEmailReportData.reportname.length == 0
      ) {
        return;
      } else if (
        this.AutoEmailReportData.selectedcinema.length == 0 &&
        this.AutoEmailReportData.cine_id == null
      ) {
        return;
      } else if (
        this.AutoEmailReportData.reportname ==
          "Distributor Collection Report" &&
        this.AutoEmailReportData.distributorname.length == 0 &&
        this.AutoEmailReportData.d_id == null
      ) {
        return;
      } else if (
        this.AutoEmailReportData.reportname ==
          "Distributor Collection Report" &&
        this.AutoEmailReportData.moviename.length == 0 &&
        this.AutoEmailReportData.movie_id == null
      ) {
        return;
      } else if (!this.AutoEmailReportData.datetime) {
        return;
      } else if (!this.startTime2) {
        return;
      } else if (
        this.frequencyDaily === false &&
        this.frequencyWeekday === false
      ) {
        return;
      } else if (weekarr.length === 0) {
        this.msgweek = "Please Select at least One Day.";
        return;
      } else {
        if (
          this.AutoEmailReportData.reportname != "Distributor Collection Report"
        ) {
          this.AutoEmailReportData.distributorname = "";
          this.AutoEmailReportData.d_id = null;

          this.AutoEmailReportData.moviename = "";
          this.AutoEmailReportData.movie_id = null;
        }
        this.AutoEmailReportData.datetime = this.convertTime(
          this.AutoEmailReportData.datetime,
          this.startTime2
        );
        let payload = {
          details: this.AutoEmailReportData,
          weekdays: this.weekDays,
        };
        MasterService.EditAutoEmailReport(payload)
          .then((response) => {
            const { data } = response;

            if (data.status) {
              this.$router.push({
                path: "/master/auto-email-report",
              });
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AutoEmailReportComponents/editautoemailreport.vue